import { ApolloClient, InMemoryCache, HttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { WebSocket } from 'ws';
import { configBase } from '@/config/base';

const httpLink = new HttpLink({
    uri: 'https://smart-search.sembo.com/graphql',
});

const wsLink = new GraphQLWsLink(
    createClient({
        url: 'wss://smart-search.sembo.com/graphql',
        webSocketImpl: configBase.isTest ? WebSocket : undefined,
    })
);

const splitLink = split(
    ({ query }) => {
        const definition = getMainDefinition(query);
        return (
            definition.kind === 'OperationDefinition' &&
            definition.operation === 'subscription'
        );
    },
    wsLink,
    httpLink
);

const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
});

export default client;
